//REACT
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//YUP
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

//MUI
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import {
  FormControlLabel,
  List,
  MenuItem,
  Switch,
  Typography,
} from "@mui/material";

//COMPONENTS
import { CustomScrollbar } from "../../../customScrollbar/CustomScrollbar";

//DATEFIELD
import { DatePicker } from "@mui/lab";
import RoleBasedContent from "../../../../../contents/RoleBasedContent";

const schema = yup.object().shape({
  code: yup.string().required(),
  associated: yup.boolean().required(),
  associatedDate: yup.string(),
  // associatedDate: yup.string().datetime(),
  voucherType: yup.string(),
});

const Form = ({ mode = "create", handleSave, currentProduct }) => {
  const isEdit = mode === "edit";
  const { id, dataCreation, ...voucherExt } = currentProduct;

  const defaultValues = {
    ...{
      code: "",
      associated: false,
      associatedDate: null,
      voucherType: "",
    },
    ...voucherExt,
  };

  const form = useForm({
    defaultValues,
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { register, handleSubmit, formState, reset, setValue } = form;
  const { errors, isValid, isDirty } = formState;

  useEffect(() => {
    reset(defaultValues);
  }, [currentProduct]);

  const onSubmit = (data) => {
    handleSave(data);
  };

  //BOOLEAN LOGIC

  const booleanOptions = [true, false];

  //Associated

  const [selectedAssociated, setSelectedAssociated] = useState(
    currentProduct.associated || ""
  );

  const handleSelectAssociated = (associated) => {
    setSelectedAssociated(associated);
    setValue("associated", associated);
  };

  useEffect(() => {
    setSelectedAssociated(currentProduct.associated || "false");
    reset(defaultValues);
  }, [currentProduct]);

  return (
    <CustomScrollbar>
      <Box
        id="voucherExtForm"
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        maxWidth="95%"
        maxHeight="35vw"
      >
        <Grid2 container spacing={3}>
          <Grid2 xs={12}>
            <Typography variant="h3" color="primary">
              Voucher Ext {isEdit ? "details" : "creation"}
            </Typography>
          </Grid2>
          <Grid2 xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Code"
              color="primary"
              fullWidth
              required
              error={!!errors.code}
              helperText={errors.code?.message}
              {...register("code")}
            />
          </Grid2>

          <Grid2 xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Voucher Type"
              color="primary"
              fullWidth
              required
              error={!!errors.voucherType}
              helperText={errors.voucherType?.message}
              {...register("voucherType")}
            />
          </Grid2>

          <Grid2 xs={12} lg={6}>
            <TextField
              disabled
              InputLabelProps={{ shrink: true }}
              label="Associated"
              color="primary"
              fullWidth
              select
              value={selectedAssociated}
              onChange={(event) => handleSelectAssociated(event.target.value)}
              title="Associated"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={6}>
            <TextField
              disabled={isEdit}
              InputLabelProps={{ shrink: true }}
              label="Associated date"
              type="date"
              color="primary"
              fullWidth
              error={!!errors.associatedDate}
              helperText={errors.associatedDate?.message}
              {...register("associatedDate")}
            />
            <DatePicker />
          </Grid2>

          <RoleBasedContent>
            <Grid2 xs={12}>
              <Tooltip arrow title={(false && "a") || ""}>
                <LoadingButton
                  type="submit"
                  loading={false}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  sx={{
                    boxShadow: "none",
                    padding: "5px 12px 4px 12px",
                  }}
                  color="primary"
                  onClick={() => {}}
                  // disabled={isDirty && !isValid}
                >
                  Save
                </LoadingButton>
              </Tooltip>
            </Grid2>
          </RoleBasedContent>
        </Grid2>
      </Box>
    </CustomScrollbar>
  );
};

export default Form;
